module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAMCAYAAABfnvydAAAACXBIWXMAAAsSAAALEgHS3X78AAAAU0lEQVQYlWPABjT2/DLQ2PMrACTFiC4PkmRgYNjPwMAgwMDAEMiER/ICAwPDAUY8ko43XNg+MOKTBLsBnyQIoLgBGyBsBVGOxKeIYEDhD2oGBgYAJ7Y1PEjg40oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/left-carot-small.png
// module id = 401
// module chunks = 0